// Single source of truth for the homepage partner-logo + certification strip.
// Manufacturers render as <img>. Certifications render as <img> when imageUrl
// is set, or as a styled CertBadge pill as fallback.
//
// certifications is intentionally empty — the four placeholder pills (Trusted
// Partner / Accredited Contractor / Certified Installer / Insured & Bonded)
// were removed 2026-05-21 because they read as unfinished next to the real
// manufacturer logos. Add real entries here when artwork is ready — BBB
// Accredited Business, GAF Master Elite, Ohio contractor license, insurance
// carrier — preferring imageUrl over the pill fallback.

export const manufacturers = [
  { name: 'GAF', imageUrl: '/assets/images/GAF_3D_logo_1_-1767901680135.jpg' },
  { name: 'Atlas', imageUrl: '/assets/images/atlas-logo.webp' },
  { name: 'Owens Corning', imageUrl: '/assets/images/Owens_Corning_3D_logo_1_-1767901713667.jpg' },
  { name: 'TAMKO', imageUrl: '/assets/images/TAMKO_3D_logo-1767901576132.jpg' },
];

export const certifications = [];
